import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, Label, Input, Tooltip, FormField, getPaletteColor } from 'pcln-design-system'
import { Calendar, Warning } from 'pcln-icons'

const StyledLabel = styled(Label)`
  z-index: ${(props) => props.zIndex + 1};
`

const StyledInput = styled(Input)`
  height: ${(props) => props.height}px;
  z-index: ${(props) => props.zIndex};
  font-size: 14px;
  background-color: ${getPaletteColor('background.lightest')};
`

const CalendarIcon = styled(Calendar)`
  z-index: ${(props) => props.zIndex + 1};
`

const WarningIcon = styled(Warning)`
  z-index: ${(props) => props.zIndex + 1};
`

function DateField({
  className,
  isOpen,
  name,
  label,
  value,
  error,
  isMobile,
  zIndex,
  hideTooltip,
  onFocus,
  onBlur,
  ...props
}) {
  const inputHeight = isMobile ? 46 : 56
  const showError = !hideTooltip && error !== ''

  return (
    <Box className={className} {...props}>
      <FormField>
        <StyledLabel autoHide id={`${name}-label`} htmlFor={name} width='auto' zIndex={zIndex}>
          {label}
        </StyledLabel>
        <CalendarIcon color='primary' zIndex={zIndex} />
        <StyledInput
          id={name}
          name={name}
          placeholder={label}
          value={value}
          autoComplete='off'
          readOnly
          height={inputHeight}
          zIndex={zIndex}
          onFocus={onFocus}
          onBlur={onBlur}
          aria-labelledby={`${name}-label`}
          color={error && 'error'}
        />
        {showError && <WarningIcon color='error' size={20} zIndex={zIndex} />}
      </FormField>
      {!isOpen && showError && (
        <Tooltip bottom right color='error' zIndex={zIndex + 2}>
          {error}
        </Tooltip>
      )}
    </Box>
  )
}

DateField.displayName = 'DateField'

DateField.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  error: PropTypes.string,
  zIndex: PropTypes.number,
  hideTooltip: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
}

DateField.defaultProps = {
  className: '',
  isMobile: false,
  hideTooltip: false,
  zIndex: 3,
  error: '',
  label: '',
  placeholder: '',
}

export default memo(DateField)
